import styled, { css } from "styled-components";
import { colors } from "../../../../../theme/theme";

interface NavProps {
	show: boolean;
}

const wrapperModifiers = {
	show: () => css`
		transition: all 0.3s linear;
		width: 70px !important;

		@media (max-width: 900px) {
			width: 100% !important;
			height: 0% !important;
		}
	`,
};

export const Nav = styled.nav<NavProps>`
	${({ show }) => css`
		background: ${colors.greyscale.black};
		position: fixed;
		left: 0;
		top: 70px;
		height: calc(100% - 70px);
		width: 210px;
		z-index: 9;

		transition: all 0.3s linear;
		display: grid;
		grid-template-rows: 1fr auto;
		gap: 8px;
		padding: 40px 0 16px;

		.config-item-nav {
			margin: auto;
			width: calc(100% - 8px);
		}

		.item-name {
			flex-grow: 1;
		}

		@media (max-width: 576px) {
			width: 100%;
			height: auto;
		}

		@media (min-width: 577px) and (max-width: 768px) {
			width: 100%;
			height: auto;
		}

		@media (min-width: 769px) and (max-width: 900px) {
			width: 100%;
			height: 50%;
		}

		${!show && wrapperModifiers.show()};
	`}
`;

export const MenuList = styled.ul<NavProps>`
	${({ show }) => css`
		height: 100%;
		padding: 0 4px;

		display: flex;
		flex-direction: column;

		@media (max-width: 900px) {
			display: ${show ? "block" : "none"};
		}
	`}
`;

export const MenuIcon = styled.div`
	font-size: 40px;
	color: white;
	position: fixed;
	left: 5%;
	z-index: 9999;

	.hamburger-react {
		margin-top: 12px !important;
	}
`;
